export const SET_VOD_ASSET = "SET_VOD_ASSET";
export const CLEAR_VOD_ASSET = "CLEAR_VOD_ASSET";
export const SET_VOD_DETAILS = "SET_VOD_DETAILS";
export const CLEAR_VOD_DETAILS = "CLEAR_VOD_DETAILS";
export const CLEAR_VOD_ITEM = "CLEAR_VOD_ITEM";